import { render, staticRenderFns } from "./EventName.vue?vue&type=template&id=5b0a4b70&scoped=true"
import script from "./EventName.vue?vue&type=script&lang=js"
export * from "./EventName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0a4b70",
  null
  
)

export default component.exports